import {
  GET_CASES,
  CASES_ERROR,
  GET_CASES_RECEIVES,
  GET_CASES_IMPLICATED,
  GET_CASES_IMPLICATED_DETAIL,
  GET_CASES_DOCUMENTS,
  GET_CASES_SURE,
  GET_CASES_CAR_TYPE,
  GET_CASES_BRAND,
  GET_CASES_COMUNE,
  GET_CASES_COMPANY,
  POST_CASES_BITACORA,
  POST_CASES_IMPLICADO,
  GET_CASES_COUNTRY,
  CLEAN_STATE
} from '../types'
import client from '../../lib/api-client'
import {
  API_GESTION_CASES,
  API_GESTION_CASES_RECEIVE,
  API_GETION_CASES_IMPLICATED,
  API_GETION_CASES_DOCUMENTS,
  API_GETION_CASES_IMPLICATED_DETAIL,
  API_GETION_CASES_COMPANY,
  API_GETION_CASES_COMUNES,
  API_GETION_CASES_BRAND,
  API_GETION_CASES_POST_BITACORAS
} from '../../lib/constants'

export const getCases = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GESTION_CASES}?q=${q}`)
    if (res.data.code === 1) {
      dispatch({
        type: GET_CASES,
        payload: res.data.object
      })
    } else {
      dispatch({
        type: CASES_ERROR,
        payload: []
      })
    }
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: 'Menssge'
    })
  }
}

export const getCasesImplicated = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GETION_CASES_IMPLICATED}?q=${q}`)
    dispatch({
      type: GET_CASES_IMPLICATED,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

export const getCasesDocuments = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GETION_CASES_DOCUMENTS}?q=${q}`)
    dispatch({
      type: GET_CASES_DOCUMENTS,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

export const getCasesImplicatedDetail = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GETION_CASES_IMPLICATED_DETAIL}?q=${q}`)
    dispatch({
      type: GET_CASES_IMPLICATED_DETAIL,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

// -------------------------Combo Box ------------------------------------------------

export const getCasesRecives = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GESTION_CASES_RECEIVE}?q=${q}`)
    dispatch({
      type: GET_CASES_RECEIVES,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

export const getCBCasesSure = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GESTION_CASES_RECEIVE}?q=${q}`)
    dispatch({
      type: GET_CASES_SURE,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

export const getCBCasesCompany = () => async (dispatch) => {
  try {
    const res = await client.get(`${API_GETION_CASES_COMPANY}`)
    dispatch({
      type: GET_CASES_COMPANY,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

export const getCBCasesCarType = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GESTION_CASES_RECEIVE}?q=${q}`)
    dispatch({
      type: GET_CASES_CAR_TYPE,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

export const getCBCasesCarBrand = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GETION_CASES_BRAND}?q=${q}`)
    dispatch({
      type: GET_CASES_BRAND,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

export const getCBCasesCommune = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GETION_CASES_COMUNES}?q=${q}`)
    dispatch({
      type: GET_CASES_COMUNE,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}
export const getCBCountry = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GESTION_CASES_RECEIVE}?q=${q}`)
    dispatch({
      type: GET_CASES_COUNTRY,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

// -------------------------Post ------------------------------------------------
export const postCasesBitacora = (body) => async (dispatch) => {
  try {
    const res = await client.post(`${API_GETION_CASES_POST_BITACORAS}`, body)
    dispatch({
      type: POST_CASES_BITACORA,
      payload: res.data.message
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

export const postCasesImplicado = (body) => async (dispatch) => {
  try {
    const res = await client.post(`${API_GETION_CASES_IMPLICATED_DETAIL}`, body)
    dispatch({
      type: POST_CASES_IMPLICADO,
      payload: res.data.message
    })
  } catch (e) {
    dispatch({
      type: CASES_ERROR,
      payload: console.log(e)
    })
  }
}

export const cleanStateCase = () => async (dispatch) => {
  dispatch({
    type: CLEAN_STATE,
    payload: []
  })
}
